import type { PriceInformation, Prices } from 'src/app/api/owcc/models';

export enum DiscountId {
  ManufacturerDiscountEnvironmentalBonus = 'MANUFACTURER_DISCOUNT_ENVIRONMENTAL_BONUS'
}

export class Price {
  public constructor(
    public readonly value?: number,
    public readonly formattedValue?: string
  ) {}
}

export function discountedOrConfigurationPrice(priceInformation: PriceInformation): Prices | undefined {
  return priceInformation?.discountedPrice ?? priceInformation?.configurationPrice;
}
